import { setStarredChatsListFailed, setStarredChatsListPending, setStarredChatsListSucceed } from './actions';
import { getStarredChatsV2 } from './getStarredChatsV2';
import { IStarredChatsListRequest } from './types';
import { transformItemListChatV1 } from '../../mappers/transformItemListChatV1';
import { isShowSubAgentChatListSelector } from '../../selectors';
import { fetchStarredChats } from '../../services/chatsList';
import { CHATS_ON_PAGE_LIMIT } from '../../types/chatList';
import { TThunkAction } from '../../types/redux/thunk';
import { ERoute } from '../../types/route';
import { isChatsV2Enabled } from '../../utils/isChatsV2Enabled';
// eslint-disable-next-line import/no-cycle
import { setRoute } from '../route';

/**
 * Получить список важных чатов
 */
export const getStarredChats =
  ({ timestampStarred }: IStarredChatsListRequest): TThunkAction<Promise<void>> =>
  async (dispatch, getState, context) => {
    const state = getState();

    const isChatsV2 = isChatsV2Enabled(context.config);

    if (isChatsV2) {
      dispatch(getStarredChatsV2({ timestampStarred }));

      return;
    }

    const {
      masterFilters: { selectedSubAgentId },
    } = state;

    const subAgentRealtyUserId = isShowSubAgentChatListSelector(state) ? selectedSubAgentId : undefined;

    dispatch(setStarredChatsListPending({ timestampStarred }));

    const starredChats = await fetchStarredChats(context, {
      parameters: {
        limit: CHATS_ON_PAGE_LIMIT,
        timestampMs: timestampStarred,
        subAgentRealtyUserId,
      },
    });

    if (starredChats === null) {
      dispatch(setStarredChatsListFailed());

      return;
    }

    const chats = starredChats.map(transformItemListChatV1);
    dispatch(setStarredChatsListSucceed({ chats }));

    /**
     * Ставим активный пункт меню - спам и сбрасываем восстановленный id из архива,
     * чтобы обнулить открытый чат при переходе в архив.
     */
    dispatch(setRoute({ route: ERoute.Starred }));
  };
